const ossApi = '/ossApi'
let hostname = window.location.hostname
console.log(hostname)
// 社工
let areaCode = '31'
let tenantCode = '310100000000000001'
let title = '锦旗软件'
let imageUrl = ossApi + '/jqrj'
let username = 'jqrjwzgly'
let password = 'BJjrWZ369'
let systemType = 'other'

export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  areaCode,
  systemType
}
